import React, { useEffect, useState } from 'react';
import { shieldIcon } from '../../images/btnIcons';
import { axisMaxLogo } from '../../images/images';

const IVCWelcomeScreen = ({ ivcVideoUrl }) => {
    const [redirectionCountDown, setRedirectionCountDown] = useState(1);
    let redirectionInterval = null;

    useEffect(() => {
        handleRedirection();
        return () => {
            if(redirectionInterval){
                clearInterval(redirectionInterval);
            }
        }
    },[])

    useEffect(()=>{
        console.log("In USE EFFECT CLEAR :: ",redirectionCountDown);
        if(redirectionCountDown === 0){
            console.log("REDIRECT :: ",redirectionCountDown);
            clearInterval(redirectionInterval);
            window.open(ivcVideoUrl, '_self');
        }
    },[redirectionCountDown])

    const handleRedirection = () => {
        redirectionInterval = setInterval(() => {
            setRedirectionCountDown((prevCount) => (prevCount - 1));
        }, 1000);
    }

    return (
        <div className='wlcom-screen-cntnr'>
            <div className='wlcom-screen'>
                <div className='wlcm-scrn-logo'>
                    <img src={axisMaxLogo} alt='MAX_LOGO' />
                </div>
                <div className='wlcm-text'>
                    <h3>Welcome to</h3>
                    <h3>Video call verification</h3>
                    <div className='ivc-ins-txt'><p>You’ll soon be connected to one of our executives</p></div>
                    {/* <div className='ivc-ins-txt'><p>You’ll be redirected in {redirectionCountDown} seconds</p></div> */}
                    <div className='wlcm-footer'>
                        <img src={shieldIcon} alt='PROTECTION_LOGO' />
                        <p>Your data is 100% safe</p>
                    </div>
                </div>
                {/* <div className='ivc-btn-cntnr'>
                    <button className='ivc-btn' onClick={() => { window.open("/ivc-verification", "_self") }}>Let’s Start</button>
                </div> */}
            </div>
        </div>
    );
};

export default IVCWelcomeScreen;